import type { TaskStatus } from "@/api/types";
export const STATUS_LABELS: Record<TaskStatus, string> = {
  in_progress: "В работе",
  paused: "На паузе",
  processing: "Обработка",
  needs_confirmation: "Нужна проверка",
  completed: "Завершено",
  stopped: "Остановлено",
};
export const RUN_STATUS_LABELS: Record<string, string> = {
  queued: "В очереди", running: "Выполняется", completed: "Готово",
  failed: "Ошибка", cancelled: "Отменено",
};
export const RUN_STAGE_LABELS: Record<string, string> = {
  queued: "Ожидает начала", starting: "Подготовка записи", normalized: "Запись подготовлена",
  diarized: "Голоса разделены", transcribing: "Распознаём речь", transcribed: "Речь распознана",
  structuring: "Распределяем ответы по вопросам", processing: "Обрабатываем запись",
  complete: "Обработка завершена", completed: "Обработка завершена",
  superseded: "Заменено новой обработкой", failed: "Обработка прервана",
};
export function duration(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(safe / 3600);
  return [
    ...(hours ? [String(hours)] : []),
    String(Math.floor(safe / 60) % 60).padStart(2, "0"),
    String(safe % 60).padStart(2, "0"),
  ].join(":");
}
export function dateTime(value: string | null): string {
  if (!value) return "Не указано";
  const date = new Date(value);
  return Number.isNaN(date.valueOf())
    ? "Не указано"
    : new Intl.DateTimeFormat("ru", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(date);
}
export function bytes(value: number): string {
  return value >= 1024 ** 3
    ? `${(value / 1024 ** 3).toFixed(1)} ГБ`
    : `${(value / 1024 ** 2).toFixed(1)} МБ`;
}
export function localDateTime(value: string | null): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.valueOf())) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}
export function fromLocalDateTime(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.valueOf()) ? null : d.toISOString();
}
